import { useQuery } from '@tanstack/react-query';
import type { PlatformPlan } from '@barbeiropro/contracts';
import { api } from '@/lib/api';

export function usePlans() {
  return useQuery({ queryKey: ['platform', 'plans'], queryFn: () => api.get<PlatformPlan[]>('/platform/plans') });
}
